__turbopack_context__.v({
  "_text": "Option-module-scss-module__4aAzQG___text",
  "app_light_theme": "Option-module-scss-module__4aAzQG__app_light_theme",
  "option": "Option-module-scss-module__4aAzQG__option",
  "option__helpText": "Option-module-scss-module__4aAzQG__option__helpText",
  "option__selected": "Option-module-scss-module__4aAzQG__option__selected",
  "option__title": "Option-module-scss-module__4aAzQG__option__title",
});
